import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@repo/ui/src/components/Icons/CloseIcon';
import { classNames } from '@repo/ui/src/utils/classNames';
import useTranslation from '@components/Translation/useTranslation';

export interface MessageProps {
  closeIcon?: boolean;
  closeLabel: string;
  text: string;
  setOpen: (open: boolean) => void;
}

const Message = ({ closeIcon, closeLabel, text, setOpen }: MessageProps) => {
  const { t } = useTranslation();

  return (
    <Box>
      {closeIcon && (
        <IconButton
          onClick={() => setOpen(false)}
          color="primary"
          sx={{ top: 0, float: 'right' }}
          aria-label={
            closeLabel ||
            t('genericContent.closeIconButtonLabel', undefined, { default: 'close dialog' })
          }
          size="large"
        >
          <CloseIcon />
        </IconButton>
      )}
      <p
        className={classNames(
          'tw-text-white tra-text-web-body-m',
          closeIcon ? 'tw-p-4 tw-pr-8' : 'tw-py-1 tw-px-3',
        )}
      >
        {text}
      </p>
    </Box>
  );
};

export default Message;
